import { toJS, observable, action, makeObservable, computed } from 'mobx';
import { simultaneousInterpretation } from './index';
import { getInterpretStatus } from '@/api';

/**
 * TODO 逐步把音视频会议人员相关数据以及接口放到当前model下  主要是meeting的人员数据
 */
class Members {
  constructor() {
    makeObservable(this);
  }

  /**
   * 译员列表信息
   */
  @observable interpreters: defs.api.ConferenceInterpretersConfiguration[] = [];

  // /**
  //  * 译员列表的map对象
  //  */
  // @observable interpretersMap: Map<number, > = new Map();

  /**
   * 译员麦克风的状态, 译员不管在那个频道开麦都需要在房间展示话筒
   */
  @observable interpretersAudioStatusMap: Map<string, any> = new Map();

  @action
  async getInterpreters(params: { channelId: number }) {
    const ret = await getInterpretStatus(params);
    if (ret.status === 1) {
      if (ret.data?.interpreters) {
        // 全局维护的是否开启同声传译的状态 先放在simultaneousInterpretation实例存储
        simultaneousInterpretation.setInterpretationStatus(ret.data?.interpretationStatus || 1);
        ret.data?.interpreters.forEach((item) => {
          this.setInterpretersAudioStatus(String(item.yxMeetingUid), item.mikeStatus === 1);
        });
        this.interpreters = ret.data?.interpreters;
        return ret.data?.interpreters;
      }
    }
    return [];
  }
  // 更新译员当前所在的传译频道
  @action
  async updateInterpreterOutputChannelLanguage(params: {
    interpreterYxMeetingUid: number;
    language: string;
  }) {
    const { interpreterYxMeetingUid, language } = params;
    // language 为空表示在主频道
    const interpreters = JSON.parse(JSON.stringify(this.interpreters)) || [];
    interpreters.forEach((item: defs.api.ConferenceInterpretersConfiguration) => {
      if (item.yxMeetingUid === interpreterYxMeetingUid) {
        item.outputChannelLanguage = language;
      }
    });
    this.interpreters = observable(interpreters);
  }
  /**
   * 设置译员麦克风的状态
   * @param status
   */
  @action
  async setInterpretersAudioStatus(yxuid: string, status: boolean) {
    const interpreters = JSON.parse(JSON.stringify(this.interpreters)) || [];
    interpreters.forEach((item: defs.api.ConferenceInterpretersConfiguration) => {
      if (String(item.yxMeetingUid) === yxuid) {
        item.mikeStatus = status ? 1 : 2;
      }
    });
    this.interpreters = observable(interpreters);
    this.interpretersAudioStatusMap.set(yxuid, status);
  }

  @computed
  get interpretersObj() {
    return this.interpreters.reduce((pre, cur) => {
      pre[cur.yxMeetingUid!] = cur;
      return pre;
    }, {} as { [k: string]: defs.api.ConferenceInterpretersConfiguration });
  }
}

export default Members;
